<div class="sidebar">
  <nav class="sidebar-nav">
    <ul class="nav">
      <li class="nav-item nav-dropdown">
        <a routerLinkActive="active" href="{{homeRouteUrl}}">
          <span class="nav-link nav-dropdown-toggle nav-item-primary">
            <kendo-svgicon [icon]="icons.home"></kendo-svgicon>
            <div id="title--99" class="nav-item-small--title">Home</div>
          </span>
        </a>
      </li>
      @for (prime of menuItems; track prime; let $idx = $index) {
        <li class="nav-item nav-dropdown" [class.nav-item-with-children]="prime.children.length > 1" routerLinkActive="open">
          @if (prime.children.length > 1) {
            <span class="nav-link nav-dropdown-toggle nav-item-primary" (mouseover)="show($idx)" (mouseout)="hide()">
              <div class="">
                <kendo-svgicon [icon]="prime.icon"></kendo-svgicon>
              </div>
              <div id="title--{{$idx}}" class="nav-item-small--title">{{prime.name}}</div>
            </span>
            <ul class="nav-dropdown-items" (mouseover)="show($idx)" (mouseout)="hide()">
              @for (child of prime.children; track child) {
                <li class="nav-item">
                  <a class="nav-link" routerLinkActive="active" [routerLink]="['/', prime.state, child.state]" (click)="menuLinkClicked(prime, child)">
                    {{child.name}}
                  </a>
                </li>
              }
            </ul>
          }
          @if (prime.children.length === 1) {
            <a routerLinkActive="active" [routerLink]="['/', prime.state, prime.children[0].state]" (click)="menuLinkClicked(prime, prime.children[0])">
              <span class="nav-link nav-dropdown-toggle nav-item-primary">
                <kendo-svgicon [icon]="prime.icon"></kendo-svgicon>
                <div id="title--{{$idx}}" class="nav-item-small--title">{{prime.name}}</div>
              </span>
            </a>
          }
        </li>
        @if (prime.children.length === 0) {
        }
      }

    </ul>
  </nav>
</div>